import { atom, useSetAtom } from "jotai";
import { useFetchWithAccessToken } from "@/functions/useFetchWithAccessToken"; // Assuming you want to reuse your fetch wrapper
import { BackendApiUrl } from "@/functions/BackendApiUrl";

interface PermissionResponse {
    permissions: string[];
}

// Private Atom (Writeable only internally)
const _internalPermissionsAtom = atom<string[] | null>(null);

// Public Atom (Read-only for components)
export const permissionsAtom = atom((get) => get(_internalPermissionsAtom));

export const useLoadPermissions = () => {
    const setPermissions = useSetAtom(_internalPermissionsAtom);
    const { fetchGET } = useFetchWithAccessToken(); // Optional: use your existing fetcher

    const loadPermissions = async () => {
        try {
            const res = await fetchGET<PermissionResponse>(BackendApiUrl.permission.get); 
            
            if (res.problem || res.error) {
                console.error(res.problem || res.error);
                setPermissions([]);
            } else {
                setPermissions(res.data?.permissions || []);
            }
        } catch (error) {
            console.error("Error fetching permissions:", error);
            setPermissions([]);
        }
    };

    return loadPermissions;
};